export class GeneralAppVariables {
    idleTimeInMinutes: number;
}